var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "custom-tree-node custom-node-line",
      class: { findErr: _vm.error },
    },
    [
      _c(
        "div",
        {
          class: [
            "custom-content",
            !_vm.isHiddenRelation && _vm.relations && _vm.relations.length > 0
              ? "custom-have-cr"
              : "",
          ],
        },
        [
          _c(
            "div",
            { staticClass: "custom-flex", class: { hasErr: _vm.error } },
            [
              _c(
                "div",
                {
                  staticClass: "deleteBtn",
                  on: { click: _vm.deleteCondition },
                },
                [_c("div", { staticClass: "deleteBar" })]
              ),
              !_vm.isSelect
                ? _c("condition-name", {
                    ref: "conName",
                    staticClass: "mr-10",
                    on: {
                      getDateName: _vm.setDataName,
                      change: _vm.selectName,
                    },
                  })
                : _vm._e(),
              _vm.dataName && _vm.relations && _vm.relations.length
                ? _c(
                    "div",
                    {
                      key: _vm.refreshKey,
                      staticClass: "condition-relation-box mr-10",
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { size: "small", placeholder: "请选择条件" },
                          on: {
                            change: _vm.onChangeRelation,
                            blur: _vm.blur,
                            focus: _vm.focus,
                          },
                          model: {
                            value: _vm.relationsVal,
                            callback: function ($$v) {
                              _vm.relationsVal = $$v
                            },
                            expression: "relationsVal",
                          },
                        },
                        _vm._l(_vm.relations, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.screenText || item.label,
                              value: item.screenType || item.value,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.conditionType
                ? _c("input-render", {
                    key: _vm.refreshKey + 2,
                    ref: "inputRender",
                    attrs: {
                      options: _vm.inputOptions,
                      num: _vm.conditionType,
                      type: _vm.inputType[_vm.conditionType],
                      glId: _vm.glId,
                      error: _vm.error,
                    },
                    on: { change: _vm.onChangeValue },
                    model: {
                      value: _vm.inputValue,
                      callback: function ($$v) {
                        _vm.inputValue = $$v
                      },
                      expression: "inputValue",
                    },
                  })
                : _vm._e(),
              _vm.conditionType == 4 && _vm.inputValue.length
                ? _c("span", { staticClass: "advancedCopyBtn" }, [
                    _c("i", {
                      staticClass: "el-icon-document-copy copy-icon",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.copyTagValue(
                            _vm.inputValue,
                            _vm.conditionType
                          )
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _c("transition", { attrs: { name: "el-fade-in-linear" } }, [
                _vm.error
                  ? _c("span", { staticClass: "error-warn" }, [
                      _vm._v(_vm._s(_vm.errorText)),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }